// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"356":"91437a1a","911":"b9e4c758"}[chunkId] + ".chunk.js";
};